import { useTranslation } from "react-i18next";
import SectionHead from "../../components/shared/SectionHead";
import BentoCard from "./BentoCard";
import { FEATURES } from "./features";

export default function WhyRayaBot() {
  const { t } = useTranslation("landing");

  return (
    <section
      id="features"
      className="scroll-mt-24 py-16 sm:!py-20 lg:!py-24"
    >
      <div className="mx-auto max-w-container px-5 sm:!px-7">
        {/* Head */}
        <SectionHead
          eyebrow={t("features.eyebrow")}
          title1={t("features.title1")}
          titleGrad={t("features.titleGrad")}
          title2={t("features.title2")}
          subtitle={t("features.sub")}
        />

        {/* Bento Grid */}
        <div className="grid grid-cols-1 gap-4 sm:!grid-cols-2 sm:!gap-5 lg:!grid-cols-6 lg:!gap-5">
          {FEATURES.map((feature, i) => (
            <BentoCard
              key={feature.key}
              feature={feature}
              index={i}
            />
          ))}
        </div>
      </div>
    </section>
  );
}